import { AttributeService } from './attribute'

import { AttributeGroupService } from './attributeGroup'

import { CategoryService } from './category'

import { PictureService } from './picture'

import { BrandService } from './brand'

import { NoBookService } from './noBook'

import { BookService } from './book'

import { CombinationService } from './combination'

import { ChannelService } from './channel'

import { SkuService } from './sku'

import { SkuTagService } from './skuTag'

import { SpuService } from './spu'

import { PublishingHouseService } from './publishingHouse'

import { PersonnelDetailService } from './personnelDetail'

import { AwardsService } from './awards'

import { UnitService } from './unit'

import { TemplateService } from './template'

import { DictionaryTableService } from './dictionaryTable'

import { FictitiousService } from './fictitious'

import { AssistService } from './assist'

import { CardCouponService } from './cardCoupon'

import { CategoryTaxRateService } from './categoryTaxRate'

import { PageService } from './page'

import { CurrencyService } from './currency'

import { ExChangeRateService } from './exchangeRate'

import { FinancialCategoryService } from './financialCategory'

import { TaxRateService } from './taxRate'

import { ExcelService } from './excel'

import { AuditDataFormService } from './auditDataForm'

export const excel = new ExcelService('/api/commodity/excel')

export const taxRate = new TaxRateService('/api/commodity/taxRate')

export const financialCategory = new FinancialCategoryService('/api/commodity/financialCategory')

export const exChangeRate = new ExChangeRateService('/api/commodity/exchangeRate')

export const currency = new CurrencyService('/api/commodity/currency')
import { SeriesService } from './series'

export const attribute = new AttributeService('/api/commodity/attribute')

export const attributeGroup = new AttributeGroupService('/api/commodity/attributeGroup')

export const category = new CategoryService('/api/commodity/category')

export const picture = new PictureService('/api/commodity/picture')

export const brand = new BrandService('/api/commodity/brand')

export const sku = new SkuService('/api/commodity/sku')

export const skuTag = new SkuTagService('/api/commodity/skuTag')

export const spu = new SpuService('/api/commodity/spu')

export const publishingHouse = new PublishingHouseService('/api/commodity/publishingHouse')

export const personnelDetail = new PersonnelDetailService('/api/commodity/personnelDetail')

export const awards = new AwardsService('/api/commodity/awards')

export const noBook = new NoBookService('/api/commodity/noBook')

export const book = new BookService('/api/commodity/book')

export const combination = new CombinationService('/api/commodity/combination')

export const channel = new ChannelService('/api/commodity/channel')

export const unit = new UnitService('/api/commodity/unit')

export const template = new TemplateService('/api/commodity/template')

export const dictionaryTable = new DictionaryTableService('/api/commodity/dictionaryTable')

export const fictitious = new FictitiousService('/api/commodity/fictitious')

export const assist = new AssistService('/api/commodity/assist')

export const cardCoupon = new CardCouponService('/api/commodity/cardCoupon')

export const categoryTaxRate = new CategoryTaxRateService('/api/commodity/categoryTaxRate')

export const page = new PageService('/api/commodity/page')

export const series = new SeriesService('/api/commodity/series')

export const auditDataForm = new AuditDataFormService('/api/commodity/auditDataForm')
